import { createSlice } from '@reduxjs/toolkit'

import { updateCreditCard } from 'features/billing/actions/update_credit_card'
import { updatePaymentInfo } from 'features/billing/actions/update_payment_info'

const initialState = {
  status: 'initial',
  error: null
}

const changeCreditCardModalSlice = createSlice({
  name: 'changeCreditCardModal',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.status = 'initial'
      state.error = action.payload.message
    },
    setPending: (state) => { state.status = 'pending' },
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(updateCreditCard.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(updateCreditCard.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
    })
    builder.addCase(updateCreditCard.rejected, (state, action) => {
      state.status = 'completed'
      state.error = action.payload
    })
    builder.addCase(updatePaymentInfo.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(updatePaymentInfo.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
    })
    builder.addCase(updatePaymentInfo.rejected, (state, action) => {
      state.status = 'completed'
      state.error = action.payload
    })
  }
})

export const {
  reducer,
  actions: {
    setError,
    setPending,
    reset
  }
} = changeCreditCardModalSlice
